import React from "react";
import ValueCard from "./value-card";
import { VALUE_DATA } from "../../constant/value-data";

const Value = () => {
  return (
    <div
      className="text-content bg-primaryBg isolate overflow-hidden px-4 pt-28 grid place-items-center min-h-screen items-end"
      id="value"
    >
      <div
        className="relative before:absolute before:h-full before:w-full before:blur-3xl before:bg-[#9884e6] before:-z-10 after:absolute after:h-full after:w-full after:blur-3xl after:bg-[#9884e6] after:-z-10
      "
      >
        <div
          className="max-w-7xl flex flex-col border-t border-l border-r rounded-t-lg lg:rounded-t-3xl px-2 lg:px-5 pt-2 lg:pt-5
       border-[#a0a5e2] bg-white/0 backdrop-blur"
        >
          <div className="flex bg-secondaryBg flex-col gap-8 lg:gap-16 p-3 lg:p-6 rounded-t-lg lg:rounded-t-xl">
            <h1
              className="text-2xl lg:text-4xl font-bold"
              data-aos="fade-right"
              data-aos-duration={1000}
              data-aos-delay={400}
            >
              Our Value
            </h1>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 lg:gap-4">
              {VALUE_DATA.length > 0 &&
                VALUE_DATA.map((item, index) => (
                  <ValueCard {...item} key={index} />
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Value;
